module.exports = __webpack_public_path__ + "static/media/ARENAE.5a0974a0.jpg";